export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SECONDS = 10;
export const RES_PER_PAGE = 10;
export const KEY = '2432afd9-12b3-4b81-9133-5915449a9945';
export const MODAL_CLOSE_SEC = 2.5;

// API Documentation
// https://forkify-api.herokuapp.com/v2
